import { appPath } from '@shared/lib/appPath';
import styles from './Brand.module.css';

export function Brand() {
  return (
    <span className={styles.brand}>
      <span className={styles.mark} aria-hidden="true">
        <img src={appPath('/brand/tayo-gear-v2.png')} alt="" />
      </span>
      <span className={styles.name}>Tayo<span>Digitals</span></span>
    </span>
  );
}
